import { configureStore } from '@reduxjs/toolkit'
import userReducer from './slice/userSlice'
import { generalApi } from './api/generalApi'
import { productsApi } from './api/productsApi'
import { paymentApi } from './api/paymentApi'
import { getLicenseDetailsApi } from './api/getLicenseDetailsApi'
import { getLicenseProductsApi } from './api/getLicenseProductsApi'
import { userDetailsApi } from './api/userDetailsApi'
import { purchaseRequestsListApi } from './api/purchaseRequestsListApi'

export const store = configureStore({
    reducer: {
        [generalApi.reducerPath]: generalApi.reducer,
        [productsApi.reducerPath]: productsApi.reducer,
        [paymentApi.reducerPath]: paymentApi.reducer,
        [getLicenseDetailsApi.reducerPath]: getLicenseDetailsApi.reducer,
        [getLicenseProductsApi?.reducerPath]: getLicenseProductsApi?.reducer,
        [userDetailsApi?.reducerPath]: userDetailsApi?.reducer,
        [purchaseRequestsListApi?.reducerPath]: purchaseRequestsListApi?.reducer,
        userState: userReducer
    },

    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({}).concat([
            generalApi.middleware,
            productsApi.middleware,
            paymentApi.middleware,
            getLicenseDetailsApi.middleware,
            getLicenseProductsApi.middleware,
            userDetailsApi?.middleware,
            purchaseRequestsListApi?.middleware
        ])
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
